import { useState } from "react";
import { Validators } from "../../../shared/utils/Validators";
import { responderAdd } from "../../../shared/settings/apiConfig";
import { postApi } from "../../../shared/services/apiHelper";
import { Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { DateIcon, EmailIcon, HeartIcon, LocationIcon, PhoneIcon, UserIcon } from "../../../shared/icons/Icons";

import "./ResponderDetailForm.scss";

const ResponderDetailForm = (props) => {
    const { token } = useParams();

    const [userForm, setUserForm] = useState({
        fullname: { value: "", valid: false, error: '', validators: [Validators.required()] },
        email: { value: "", valid: false, error: '', validators: [Validators.email()] },
        mobile: { value: "", valid: false, error: '', validators: [Validators.phoneNumberValid()] },
        martialstatus: { value: "", valid: false, error: '', validators: [Validators.required()] },
        dateofbirth: { value: "", valid: false, error: '', validators: [Validators.required()] },
        address: { value: "", valid: false, error: '', validators: [Validators.required()] }
    });

    const inputChange = (type, event) => {
        if (type === 'mobile') {
            let value = event.target.value.replace(/\D/g, '').replace(/[^0-9]/g, '');
            if (value.length > 10) {
                value = value.slice(0, 10);
            }
            event.target.value = value;
        }

        setUserForm(prevState => {
            return {
                ...prevState,
                [type]: Validators.validateFormControl(prevState[type], event.target.value)
            }
        });
    };

    const submitResponder = () => {
        let isFormValid = true; 
        Object.keys(userForm).forEach(key => {
            let formControl = userForm[key];
            let validatedControl = Validators.validateFormControl(formControl, formControl.value);
            if (!validatedControl.valid) {
                isFormValid = false;
            }
            setUserForm(prevState => {
                return {
                    ...prevState,
                    [key]: validatedControl
                }
            })
        });

        if (isFormValid) {
            let payload = {
                data: {
                    token: token,
                    details: {
                        fullname: userForm.fullname.value,
                        email: userForm.email.value,
                        mobile: userForm.mobile.value,
                        martialstatus: userForm.martialstatus.value,
                        dateofbirth: userForm.dateofbirth.value,
                        address: userForm.address.value
                    }
                }
            }
            postApi(responderAdd, payload).then(response => {
                props.history.push(`/public/take-assessments/${response.data.data.token}`)
            }).catch(error => {
                console.log(error);
            })
        }
    }

    const isFormValid = Object.values(userForm).every((control) => control.valid);

    return (
        <div className="responder-detail d-flex align-items-center justify-content-center mg-5" style={{ margin: "3rem" }}>
            <div className="form-container pd-3" style={{ padding: "3rem" }}>
                <div className="form-title">Your Information</div>
                <div className="form-subtitle">
                    Please provide your details so the student can identify your feedback
                </div>

                <div className="row g-4 mobile-pd" style={{ padding: '0px 20px' }}>

                    <div className="col-md-6 input-section">
                        <label className="form-label icon-label">
                            <UserIcon color="rgb(92 46 145)" size="18" />
                            Full Name <span className="required">*</span>
                        </label>
                        <input type="text" className="form-control" placeholder="Full Name" value={userForm.fullname.value} onChange={(event) => inputChange("fullname", event)} />
                        <span className="text-danger">{userForm.fullname.error}</span>
                    </div>

                    <div className="col-md-6 input-section">
                        <label className="form-label icon-label">
                            <EmailIcon color="rgb(92 46 145)" size="18" />
                            Email <span className="required">*</span>
                        </label>
                        <input type="email" className="form-control" placeholder="Email" value={userForm.email.value} onChange={(event) => inputChange("email", event)} />
                        <span className="text-danger">{userForm.email.error}</span>
                    </div>

                    <div className="col-md-6 input-section">
                        <label className="form-label icon-label">
                            <PhoneIcon color="rgb(92 46 145)" size="18" />
                            Phone number <span className="required">*</span>
                        </label>
                        <input type="text" className="form-control" placeholder="Phone number" value={userForm.mobile.value} onChange={(event) => inputChange("mobile", event)} />
                        <span className="text-danger">{userForm.mobile.error}</span>
                    </div>

                    <div className="col-md-6 input-section">
                        <label className="form-label icon-label">
                            <HeartIcon color="rgb(92 46 145)" size="18" />
                            Marital Status <span className="required">*</span>
                        </label>
                        <select className="form-select" value={userForm.martialstatus.value} onChange={(event) => inputChange("martialstatus", event)}>
                            <option value="" disabled>Select Status</option>
                            <option value="Single">Single</option>
                            <option value="Married">Married</option>
                            <option value="Others">Others</option>
                        </select>
                        <span className="text-danger">{userForm.martialstatus.error}</span>
                    </div>

                    <div className="col-12 input-section">
                        <label className="form-label icon-label">
                            <DateIcon color="rgb(92 46 145)" size="18" />
                            Date of Birth <span className="required">*</span>
                        </label>
                        <input type="date" className="form-control" value={userForm.dateofbirth.value} onChange={(event) => inputChange("dateofbirth", event)} />
                        <span className="text-danger">{userForm.dateofbirth.error}</span>
                    </div>

                    <div className="col-12 input-section">
                        <label className="form-label icon-label">
                            <LocationIcon color="rgb(92 46 145)" size="18" />
                            Address <span className="required">*</span>
                        </label>
                        <textarea className="form-control" placeholder="Address" value={userForm.address.value} onChange={(event) => inputChange("address", event)}></textarea>
                        <span className="text-danger">{userForm.address.error}</span>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-center mt-4">
                    <Button className="btn-primary" disabled={!isFormValid} onClick={submitResponder}>Submit</Button>
                </div>
            </div>
        </div>
    );
};

export default ResponderDetailForm;